import React from 'react';
import { VideoPlugin } from './VideoPlugin';
import styled from 'styled-components';


import WinVideoMp4 from './videos/schoolboard/win.mp4';
import LoseVideoMp4 from './videos/schoolboard/lose.mp4';
import LandingVideoMp4 from './videos/schoolboard/landing.mp4';

import { IProps } from '../../common-types/Prop';

export const VideoContainer = styled.div`
  margin-top: 22vh;
  position: relative;
  display: inline-block;
  width: 62vw;
  overflow: hidden;
  height: 40vh;
`;
VideoContainer.displayName = 'VideoContainer';

export const SchoolBoardPlugin: React.FunctionComponent<IProps> = (props) => (
  <VideoPlugin
    {...props}
    winVideo={{ mp4: WinVideoMp4 }}
    loseVideo={{ mp4: LoseVideoMp4 }}
    landingVideo={{ mp4: LandingVideoMp4 }}
    VideoWrapper={VideoContainer}
  />
);